import { getCookie } from '@utiljs/cookie';

enum ENV {
    /** 线上环境 */
    PRODUCTION = 'prod',
    /** ST环境 */
    STAGE = 'stage',
    /** 测试环境 */
    TEST = 'test',
    /** 开发环境 */
    DEVELOPMENT = 'dev',
    /** 本地开发环境 */
    LOCALHOST = 'localhost',
    /** 未知环境，无法判断 */
    UNKNOWN = 'unknown',
}

const getEnv = (): ENV => {
    const host = window.location.host;

    if (host === 'waimaie.meituan.com' || host === 'e.waimai.meituan.com') {
        return ENV.PRODUCTION;
    } else if (host.match(/\.st\./)) {
        return ENV.STAGE;
    } else if (host.match(/\.test\./)) {
        return ENV.TEST;
    } else if (host.match(/\.dev\./)) {
        return ENV.DEVELOPMENT;
    } else if (
        host.indexOf('127.0.0.1') > -1 ||
        host.indexOf('localhost') > -1 ||
        host.indexOf('0.0.0.0') > -1
    ) {
        return ENV.LOCALHOST;
    }

    // 兜底，当做线上环境处理
    return ENV.PRODUCTION;
};

/** 是否泳道环境 */
const isSwimlane = getEnv() === ENV.TEST && window.location.host.indexOf('-sl-') !== -1;

/**
 * 获取当前泳道名称，非泳道环境返回null
 */
const getCurrentSwimlaneName = (): string | null => {
    if (isSwimlane) {
        return window.location.host.replace(/-sl-.*$/, '');
    }

    return null;
};

/** 当前是否处于 PC 客户端环境 */
const isInApp = !!window.wmSystemApi || getCookie('from_pc') === '1';

/** 当前是否处于 3.x PC 客户端环境 */
const isInOldApp = !!navigator.userAgent.match(/^MeituanWaimai\/3/);

/** 当前是否处于 4.x PC 客户端环境 */
const isInOldApp4 =
    !!navigator.userAgent.match(/^MeituanWaimai\/4/) ||
    (window.wmSystemApi && window.wmSystemApi?.getAppInfo()?.code < 5000) ||
    getCookie('from_pc_v4') === '1';

enum RuntimeType {
    /** 3.x PC 客户端 */
    CLIENT_V3 = 'clientV3',
    /** 4.x PC 客户端 */
    CLIENT_V4 = 'clientV4',
    /** 5.x PC 客户端 */
    CLIENT_V5 = 'clientV5',
    /** 浏览器 */
    BROWSER = 'browser',
}

/** 获取当前运行环境 */
const getRuntimeType = (): RuntimeType => {
    if (isInOldApp) {
        return RuntimeType.CLIENT_V3;
    } else if (isInOldApp4) {
        return RuntimeType.CLIENT_V4;
    } else if (isInApp) {
        return RuntimeType.CLIENT_V5;
    }

    return RuntimeType.BROWSER;
};

const runtimeType = getRuntimeType();

/** 当前系统是否是 xp （仅 pc 客户端） */
const isWindowsXP = window?.wmSystemApi?.getSystemInfo().isWinXP;

const ua = navigator.userAgent;

/**
 * 当前系统是否是 xp （含浏览器）
 * https://en.wikipedia.org/wiki/Windows_NT
 */
const isUniversalWindowsXP =
    isWindowsXP ||
    ua.indexOf('Windows NT 5.1') > -1 ||
    ua.indexOf('Windows NT 5.2') > -1 ||
    ua.indexOf('Windows XP') > -1;

/** 当前系统是否是 mac */
const isMac = window?.wmSystemApi?.getSystemInfo().isMac;

/**
 * 是否处于前端调试模式
 */
const isGodMode = window.location.href.replace(/#.*/, '').match(/\bgod_mode=true\b/);

const getBusinessLineByUrl = (url: string = '') => {
    let businessLine: 'waimai' | 'shangou' | 'yiyao' = 'waimai';
    if (
        url.includes('e.shangou.test.sankuai.com') ||
        url.includes('e.shangou.st.sankuai.com') ||
        url.includes('shangoue.meituan.com')
    ) {
        businessLine = 'shangou';
    }
    if (
        url.includes('yiyao.shangou.test.sankuai.com') ||
        url.includes('yiyao.shangou.st.sankuai.com') ||
        url.includes('yiyao.meituan.com')
    ) {
        businessLine = 'yiyao';
    }

    return businessLine;
};

export {
    getEnv,
    isInApp,
    ENV,
    isInOldApp,
    isGodMode,
    isSwimlane,
    getCurrentSwimlaneName,
    getBusinessLineByUrl,
    isInOldApp4,
    isWindowsXP,
    isMac,
    getRuntimeType,
    isUniversalWindowsXP,
    runtimeType,
};
